import { BarcodeScanIcon } from './BarcodeScanIcon';

/**
 * author: Simran
 * id 40365CB0-4664-4648-8C51-2E6E20A0D096
 * name barcode-scan
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barcode-scan.svg
 * tags
 */
export const BarcodeScannerIcon = BarcodeScanIcon;
export default BarcodeScannerIcon